/** "Jannik Jung" → "JJ", "jannik@x.dev" → "J" */
export const initials = (name: string | null | undefined, fallback = "?"): string => {
  const words = (name ?? "").split(/[\s@._-]+/).filter(Boolean)
  const letters =
    words.length > 1 ? `${words[0]?.[0] ?? ""}${words[1]?.[0] ?? ""}` : (words[0]?.slice(0, 2) ?? "")
  return letters.toUpperCase() || fallback
}
